import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import { getSSRRenderInputs } from '@confluence/ssr-utilities/entry-points/ssrRenderInputs.ts';

import type { TapTraitAttribute } from './formatTapTraits.ts';
import { formatTapTraits } from './formatTapTraits.ts';

export type SiteTraits = {
	attributes: TapTraitAttribute[] | null;
};

export const preloadSiteTraits = async (): Promise<void> => {
	// Check if __SSR_TAP_CONTEXT__ already has site traits
	if (window.__SSR_TAP_CONTEXT__?.site) {
		return;
	}

	const { accessStatus, cloudId } = getPreloaderFnContext();

	if (accessStatus !== 'LICENSED_USE_ACCESS' && accessStatus !== 'LICENSED_ADMIN_ACCESS') {
		return;
	}

	if (!cloudId) {
		return;
	}

	// Fallback to getSSRRenderInputs() since window.__SSR_TAP_CONTEXT__ doesn't have site
	const { tapContext } = getSSRRenderInputs();
	const attributes = formatTapTraits(tapContext?.site);

	if (!attributes) {
		return;
	}

	if (tapContext) {
		window.__SSR_TAP_CONTEXT__ = { ...tapContext };
	}
};
